import { pipe } from 'ramda';

const encode = pipe(JSON.stringify, btoa, encodeURIComponent);

export const encodeObjToUriParam = (obj: object): string | null => {
  let res: string | null = null;
  try {
    res = encode(obj);
  } catch {
    console.error('Provided obj cannot be encoded.');
  }

  return res;
};
